import { create } from 'zustand';

export type ExperienceMode = 'INTRO' | 'PLANET' | 'CONTINENT' | 'COUNTRY' | 'HUB' | 'STORE' | 'PRODUCT' | 'GYM';

interface ExperienceState {
  mode: ExperienceMode;
  introComplete: boolean;
  selectedShopId: string | null;
  selectedProductId: string | null;
  selectedContinent: string | null;
  selectedCountry: string | null;
  activeProductImageIndex: number;
  cameraTarget: [number, number, number];
  cameraPosition: [number, number, number];
  
  // Actions
  setMode: (mode: ExperienceMode) => void;
  setIntroComplete: (complete: boolean) => void;
  selectShop: (shopId: string | null) => void;
  selectProduct: (productId: string | null) => void;
  selectContinent: (continent: string | null) => void;
  selectCountry: (country: string | null) => void;
  setActiveProductImageIndex: (index: number) => void;
  setCamera: (position: [number, number, number], target: [number, number, number]) => void;
}

export const useExperienceStore = create<ExperienceState>((set) => ({
  mode: 'INTRO',
  introComplete: false,
  selectedShopId: null,
  selectedProductId: null,
  selectedContinent: null,
  selectedCountry: null,
  activeProductImageIndex: 0,
  cameraTarget: [0, 0, 0],
  cameraPosition: [0, 5, 50],

  setMode: (mode) => set({ mode }),
  setIntroComplete: (complete) => set({ introComplete: complete, mode: complete ? 'HUB' : 'INTRO' }),
  selectShop: (shopId) => set({ 
    selectedShopId: shopId, 
    mode: shopId ? 'STORE' : 'HUB',
    selectedProductId: null 
  }),
  selectProduct: (productId) => set({ 
    selectedProductId: productId,
    mode: productId ? 'PRODUCT' : 'STORE',
    activeProductImageIndex: 0
  }),
  selectContinent: (continent) => set({
    selectedContinent: continent,
    mode: continent ? 'COUNTRY' : 'CONTINENT'
  }),
  selectCountry: (country) => set({
    selectedCountry: country,
    mode: country ? 'HUB' : 'COUNTRY'
  }),
  setActiveProductImageIndex: (index) => set({ activeProductImageIndex: index }),
  setCamera: (position, target) => set({ cameraPosition: position, cameraTarget: target }),
}));
